export interface iMarketNaviagtion {
  category: string;
  key: string;
}
export enum commonId {
  recommendations = "recommendations",
}

export const marketsRoute = {
  markets: "/markets",
};
export const viewInDetail = {
  viewall: "/viewall",
};
export const MarketTabsConstants = {
  Equity: "equity",
  MutualFunds: "mutualFunds",
  PrimaryMarket: "primaryMarket",
  NCDs: "ncds",
  Futures: "futures",
  Options: "options",
  Currency: "currency",
  Commodity: "commodity",
  ETFs: "etfs",
  OptionTool: "option-tool",
};
